<template>
  <div class="price-manage">
    <div class="manage-section poster-section">
      <div class="section-header">
        <h3>海报管理</h3>
        <div class="header-actions">
          <el-tooltip content="上传新海报将替换现有海报" placement="top">
            <el-upload
              class="poster-uploader"
              action="https://www.xiaoliangtongxue.cn/api/upload-sale-image"
              :on-success="handleUploadSuccess"
              :on-error="handleUploadError"
              :before-upload="beforeUpload"
              accept=".png"
              :auto-upload="true"
              :limit="1"
              :show-file-list="false"
            >
              <template #trigger>
                <el-button type="primary" size="small" icon="Upload">
                  上传海报
                </el-button>
              </template>
            </el-upload>
          </el-tooltip>
          <el-tooltip content="删除当前显示的海报" placement="top">
            <el-button
              type="danger"
              size="small"
              icon="Delete"
              @click="deleteSaleImage"
              :disabled="!saleImageUrl"
            >
              删除海报
            </el-button>
          </el-tooltip>
        </div>
      </div>

      <div class="poster-container">
        <div class="poster-preview">
          <div class="poster-frame">
            <img
              v-if="sale"
              :src="saleImageUrl"
              alt="暂无促销海报"
              class="poster-image"
              @error="handleImageError"
            />
            <div v-else class="poster-empty">
              <el-icon :size="50" color="#909399"><Picture /></el-icon>
              <p>暂无促销海报</p>
            </div>
          </div>
          <div class="poster-tips">
            <el-alert
              title="上传提示"
              type="info"
              :closable="false"
              description="请上传PNG格式的海报图片，建议尺寸为A4比例(210×297mm)，文件大小不超过20MB"
              show-icon
            />
          </div>
        </div>
      </div>
    </div>
    <div class="manage-section">
      <div class="section-header">
        <h3>公告管理</h3>
      </div>
      <div class="message-content">
        <el-form :model="messageForm" label-width="80px">
          <el-form-item label="公告内容">
            <el-input
              v-model="messageForm.content"
              type="textarea"
              :rows="4"
              placeholder="请输入要显示的公告内容"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="saveMessage">保存公告</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="manage-section">
      <div class="section-header">
        <h3>价格列表</h3>
        <el-button type="primary" @click="showAddPrice = true"
          >添加价格</el-button
        >
      </div>

      <div class="filter-section">
        <el-select
          v-model="filterMaterial"
          placeholder="选择材质"
          clearable
          @change="handleFilter"
        >
          <el-option
            v-for="item in materials"
            :key="item"
            :label="item"
            :value="item"
          />
        </el-select>
        <el-select
          v-model="filterSize"
          placeholder="选择尺寸"
          clearable
          @change="handleFilter"
        >
          <el-option
            v-for="item in sizes"
            :key="item"
            :label="item"
            :value="item"
          />
        </el-select>
      </div>

      <el-table :data="filteredPrices" style="width: 100%">
        <el-table-column prop="material" label="材质" />
        <el-table-column prop="color" label="颜色">
          <template #default="scope">
            {{ scope.row.color ? "彩色" : "黑白" }}
          </template>
        </el-table-column>
        <el-table-column prop="page" label="单双面">
          <template #default="scope">
            {{ scope.row.page === "single" ? "单面" : "双面" }}
          </template>
        </el-table-column>
        <el-table-column prop="size" label="尺寸" />
        <el-table-column prop="price" label="单价">
          <template #default="scope">
            <span>{{ scope.row.price }}</span>
            <el-tag
              v-if="scope.row.price === 0"
              type="info"
              size="small"
              style="margin-left: 5px"
              >不可用</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150">
          <template #default="scope">
            <el-button
              style="margin-right: 10px"
              size="small"
              type="primary"
              @click="editPrice(scope.row)"
              >编辑</el-button
            >
            <el-button
              size="small"
              type="danger"
              @click="deletePrice(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog
      v-model="showAddPrice"
      :title="editingPrice ? '编辑价格' : '添加价格'"
      width="40%"
    >
      <el-form :model="newPrice" label-width="80px">
        <el-form-item label="材质">
          <el-select v-model="newPrice.material" placeholder="请选择材质">
            <el-option
              v-for="item in materials"
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="颜色">
          <el-radio-group v-model="newPrice.color">
            <el-radio :label="true">彩色</el-radio>
            <el-radio :label="false">黑白</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="单双面">
          <el-radio-group v-model="newPrice.page">
            <el-radio label="single">单面</el-radio>
            <el-radio label="double">双面</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="尺寸">
          <el-select v-model="newPrice.size" placeholder="请选择尺寸">
            <el-option
              v-for="item in sizes"
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="单价">
          <el-input-number
            v-model="newPrice.price"
            :precision="2"
            :step="0.1"
          />
          <div style="color: #909399; font-size: 12px; margin-top: 5px">
            提示：设置价格为0表示该选项不可用
          </div>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="showAddPrice = false">取消</el-button>
          <el-button type="primary" @click="savePrice">确定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ElMessage, ElMessageBox } from "element-plus";

export default {
  name: "PriceManage",
  data() {
    return {
      sale: true,
      saleImageUrl: "https://www.xiaoliangtongxue.cn/api/sale-image",
      activeTab: "price",
      materials: ["普通纸", "铜版纸", "白卡纸"],
      prices: [],
      showAddPrice: false,
      editingPrice: false,
      newPrice: {
        material: "",
        color: true,
        page: "single",
        size: "",
        price: 0,
      },
      sizes: ["A4", "A3", "B5"],
      filterMaterial: "",
      filterSize: "",
      loading: false,
      messageForm: {
        content: "",
      },
    };
  },
  computed: {
    filteredPrices() {
      let filtered = [...this.prices];

      if (this.filterMaterial) {
        filtered = filtered.filter(
          (price) => price.material === this.filterMaterial
        );
      }
      if (this.filterSize) {
        filtered = filtered.filter((price) => price.size === this.filterSize);
      }
      return filtered;
    },
  },
  methods: {
    async fetchSaleImage() {
      const response = await fetch(
        "https://www.xiaoliangtongxue.cn/api/sale-image",
        { credentials: "include" }
      );
      try {
        const data = await response.json();
        this.sale = data.success;
        // 成功解析，是JSON
      } catch (e) {
        // 解析失败，不是JSON
        console.log("Not a JSON response");
      }
    },

    refreshSaleImage() {
      this.saleImageUrl = `https://www.xiaoliangtongxue.cn/api/sale-image?t=${Date.now()}`;
    },
    beforeUpload(file) {
      const isPNG = file.type === "image/png";
      if (!isPNG) {
        ElMessage.error("只能上传PNG文件！");
        return false;
      }
      const isLt20M = file.size / 1024 / 1024 < 20;
      if (!isLt20M) {
        ElMessage.error("文件大小不能超过 20MB！");
        return false;
      }
      return true;
    },

    handleUploadSuccess(response) {
      if (response.success) {
        ElMessage.success("海报上传成功！");
        this.refreshSaleImage();
        this.fetchSaleImage();
      } else {
        ElMessage.error(response.message || "上传失败");
      }
    },

    handleUploadError() {
      ElMessage.error("上传失败，请重试");
    },
    // 添加防抖函数
    debounce(func, wait) {
      let timeout;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    },

    async fetchPrices() {
      if (this.loading) return;

      this.loading = true;
      try {
        const response = await fetch(
          "https://www.xiaoliangtongxue.cn/api/price",
          {
            credentials: "include",
          }
        );
        const data = await response.json();
        this.prices = data;
      } catch (error) {
        console.error("获取价格列表失败:", error);
        ElMessage.error("获取价格列表失败");
      } finally {
        this.loading = false;
      }
    },

    // 编辑价格
    editPrice(price) {
      this.editingPrice = true;
      this.newPrice = { ...price };
      this.showAddPrice = true;
    },

    // 保存价格
    async savePrice() {
      try {
        const url = this.editingPrice
          ? `https://www.xiaoliangtongxue.cn/api/price/${this.newPrice.id}`
          : "https://www.xiaoliangtongxue.cn/api/price";
        const method = this.editingPrice ? "PUT" : "POST";

        const response = await fetch(url, {
          method,
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
          body: JSON.stringify(this.newPrice),
        });
        const data = await response.json();
        if (data.success) {
          ElMessage.success(this.editingPrice ? "更新成功" : "添加成功");
          this.showAddPrice = false;
          this.editingPrice = false;
          this.newPrice = {
            material: "",
            color: true,
            page: "single",
            size: "",
            price: 0,
          };
          this.fetchPrices();
        } else {
          ElMessage.error(
            data.message || (this.editingPrice ? "更新失败" : "添加失败")
          );
        }
      } catch (error) {
        console.error("保存价格失败:", error);
        ElMessage.error("保存价格失败");
      }
    },

    // 删除价格
    async deletePrice(price) {
      try {
        await ElMessageBox.confirm("确定要删除该价格吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });

        const response = await fetch(
          `https://www.xiaoliangtongxue.cn/api/price/${price.id}`,
          {
            method: "DELETE",
            credentials: "include",
          }
        );
        const data = await response.json();
        if (data.success) {
          ElMessage.success("删除成功");
          this.fetchPrices();
        } else {
          ElMessage.error(data.message || "删除失败");
        }
      } catch (error) {
        if (error !== "cancel") {
          console.error("删除价格失败:", error);
          ElMessage.error("删除价格失败");
        }
      }
    },

    handleFilter() {
      // 不需要重新获取数据，因为我们使用计算属性来过滤
      return;
    },

    async fetchMessage() {
      try {
        const response = await fetch(
          "https://www.xiaoliangtongxue.cn/api/message",
          {
            credentials: "include",
          }
        );
        const data = await response.json();
        if (data.success) {
          this.messageForm.content = data.content;
        }
      } catch (error) {
        console.error("获取公告失败:", error);
        ElMessage.error("获取公告失败");
      }
    },

    async saveMessage() {
      try {
        const response = await fetch(
          "https://www.xiaoliangtongxue.cn/api/message",
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
            },
            credentials: "include",
            body: JSON.stringify({
              content: this.messageForm.content,
            }),
          }
        );
        const data = await response.json();
        if (data.success) {
          ElMessage.success("公告更新成功");
        } else {
          ElMessage.error(data.message || "公告更新失败");
        }
      } catch (error) {
        console.error("保存公告失败:", error);
        ElMessage.error("保存公告失败");
      }
    },

    async saveSaleImage() {
      try {
        const response = await fetch(
          "https://www.xiaoliangtongxue.cn/api/sale-image",
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
            },
            credentials: "include",
            body: JSON.stringify({
              image: this.saleImage,
            }),
          }
        );
        const data = await response.json();
        if (data.success) {
          ElMessage.success("海报更新成功");
        } else {
          ElMessage.error(data.message || "海报更新失败");
        }
      } catch (error) {
        console.error("保存海报失败:", error);
        ElMessage.error("保存海报失败");
      }
    },

    async deleteSaleImage() {
      try {
        await ElMessageBox.confirm("确定要删除该海报吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });

        const response = await fetch(
          "https://www.xiaoliangtongxue.cn/api/delete-sale-image",
          {
            method: "DELETE",
            credentials: "include",
          }
        );
        const data = await response.json();
        if (data.success) {
          ElMessage.success("海报删除成功");
          this.refreshSaleImage();
        } else {
          ElMessage.error(data.message || "海报删除失败");
        }
      } catch (error) {
        if (error !== "cancel") {
          console.error("删除海报失败:", error);
          ElMessage.error("删除海报失败");
        }
      }
    },
  },
  mounted() {
    this.fetchPrices();
    this.fetchMessage();
    this.fetchSaleImage();
  },
};
</script>

<style scoped>
.price-manage {
  padding: 20px;
  overflow: hidden; /* 添加溢出控制 */
}

.manage-section {
  margin-top: 20px;
  position: relative; /* 添加定位上下文 */
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 2px solid #f5f7fa;
}

.section-header h3 {
  margin: 0;
  font-size: 18px;
  color: #303133;
  font-weight: 600;
  position: relative;
  padding-left: 12px;
}

.section-header h3::before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 16px;
  background-color: #409eff;
  border-radius: 2px;
}

.filter-section {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
}

.filter-section .el-select {
  width: 200px; /* 固定选择框宽度 */
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

/* 添加表格容器样式 */
.el-table {
  width: 100% !important;
  margin-top: 10px;
  border-radius: 8px !important;
  overflow: hidden;
}

/* 表格头部样式 */
:deep(.el-table__header-wrapper th) {
  background-color: #f5f7fa !important;
  color: #606266;
  font-weight: 600;
  height: 50px;
  padding: 8px 0;
}

/* 表格内容样式 */
:deep(.el-table__body-wrapper td) {
  padding: 12px 0;
}

/* 表格行hover效果 */
:deep(.el-table__body tr:hover > td) {
  background-color: #f5f7fa !important;
}

/* 表格单元格内容垂直居中 */
:deep(.el-table .cell) {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

/* 操作按钮样式 */
:deep(.el-table .el-button) {
  padding: 8px 15px;
  border-radius: 4px;
  transition: all 0.3s;
}

:deep(.el-table .el-button:hover) {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* 价格标签样式 */
:deep(.el-table .el-tag) {
  border-radius: 4px;
  padding: 2px 6px;
}

/* 表格边框和分割线样式 */
:deep(.el-table--border) {
  border: 1px solid #ebeef5;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
}

:deep(.el-table td),
:deep(.el-table th) {
  border-bottom: 1px solid #ebeef5;
}

.message-content {
  margin-top: 20px;
  padding: 24px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  border: 1px solid #ebeef5;
  transition: all 0.3s ease;
}

.message-content:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
}

.message-content .el-textarea {
  width: 100%;
}

/* 表单样式 */
:deep(.el-form-item__label) {
  font-weight: 500;
  color: #606266;
}

:deep(.el-textarea__inner) {
  border-radius: 4px;
  padding: 12px;
  min-height: 120px !important;
  resize: vertical;
  transition: all 0.3s;
  border-color: #dcdfe6;
}

:deep(.el-textarea__inner:hover) {
  border-color: #c0c4cc;
}

:deep(.el-textarea__inner:focus) {
  border-color: #409eff;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
}

/* 保存按钮样式 */
:deep(.el-form-item:last-child) {
  margin-bottom: 0;
  margin-top: 24px;
}

:deep(.el-form-item:last-child .el-button) {
  padding: 12px 24px;
  font-weight: 500;
  letter-spacing: 1px;
  transition: all 0.3s;
}

:deep(.el-form-item:last-child .el-button:hover) {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
}

/* 提示文字样式 */
.message-content .tip {
  margin-top: 12px;
  color: #909399;
  font-size: 13px;
  line-height: 1.4;
}

.poster-section {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  padding: 20px;
  margin-bottom: 24px;
}

.poster-container {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.poster-preview {
  width: 100%;
  max-width: 800px;
}

.poster-frame {
  position: relative;
  width: 100%;
  height: 400px;
  border: 1px dashed #dcdfe6;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f5f7fa;
  overflow: hidden;
  transition: border-color 0.3s;
}

.poster-frame:hover {
  border-color: #c0c4cc;
}

.poster-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.poster-empty {
  text-align: center;
  color: #909399;
}

.poster-empty p {
  margin-top: 10px;
  font-size: 14px;
}

.poster-tips {
  margin-top: 20px;
}

.header-actions {
  display: flex;
  gap: 10px;
}

.poster-uploader {
  display: inline-block;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .poster-frame {
    height: 300px;
  }

  .header-actions {
    flex-direction: column;
    gap: 8px;
  }
}
</style> 